/* ═══════════════════════════════════════════════════
   VIDA DEL PADEL — SCROLL ANIMATIONS
   ═══════════════════════════════════════════════════ */

(function() {
  'use strict';

  // ── CSS ──────────────────────────────────────────
  var style = document.createElement('style');
  style.textContent = `
    /* Base state — elements start hidden */
    .vdp-reveal {
      opacity: 0;
      transform: translateY(32px);
      transition: opacity 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                  transform 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      will-change: opacity, transform;
    }
    .vdp-reveal.vdp-reveal--left {
      transform: translateX(-40px);
    }
    .vdp-reveal.vdp-reveal--right {
      transform: translateX(40px);
    }
    .vdp-reveal.vdp-reveal--scale {
      transform: scale(0.94);
    }
    .vdp-reveal.is-visible {
      opacity: 1;
      transform: none;
    }

    /* Stagger delay classes */
    .vdp-reveal.delay-1 { transition-delay: 0.1s; }
    .vdp-reveal.delay-2 { transition-delay: 0.2s; }
    .vdp-reveal.delay-3 { transition-delay: 0.3s; }
    .vdp-reveal.delay-4 { transition-delay: 0.4s; }
    .vdp-reveal.delay-5 { transition-delay: 0.5s; }
    .vdp-reveal.delay-6 { transition-delay: 0.6s; }

    /* Smooth page load fade-in */
    body { animation: vdpPageIn 0.5s ease-out both; }
    @keyframes vdpPageIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }

    /* Nav link hover underline effect */
    .vdp-nav-links a:not(.vdp-nav-cta):not(.vdp-nav-cart) {
      position: relative;
    }
    .vdp-nav-links a:not(.vdp-nav-cta):not(.vdp-nav-cart)::after {
      content: '';
      position: absolute;
      bottom: -3px;
      left: 0;
      width: 0;
      height: 1px;
      background: var(--orange-light);
      transition: width 0.3s ease;
    }
    .vdp-nav-links a:not(.vdp-nav-cta):not(.vdp-nav-cart):hover::after {
      width: 100%;
    }

    /* Smooth image hover zoom */
    .club-card-mini,
    .club-full-card,
    .product-card {
      transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                  border-color 0.3s ease,
                  box-shadow 0.35s ease;
    }
    .club-card-mini:hover,
    .club-full-card:hover,
    .product-card:hover {
      transform: translateY(-4px);
      box-shadow: 0 16px 48px rgba(0,0,0,0.35);
    }

    /* Button press effect */
    .btn-primary,
    .btn-ghost,
    .vdp-nav-cta {
      transition: background 0.25s, transform 0.15s, box-shadow 0.25s;
    }
    .btn-primary:active,
    .btn-ghost:active,
    .vdp-nav-cta:active {
      transform: scale(0.97);
    }

    /* Stat counter animation */
    .stat-num {
      transition: color 0.3s;
    }

    /* Coach card hover */
    .coach-card {
      transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }
    .coach-card:hover {
      transform: translateY(-6px);
    }
    .coach-img {
      transition: transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
      overflow: hidden;
    }
    .coach-card:hover .coach-img {
      transform: scale(1.03);
    }

    /* Rate card hover */
    .rate-card:not(.featured) {
      transition: transform 0.3s ease, border-color 0.3s ease;
    }
    .rate-card:not(.featured):hover {
      transform: translateY(-4px);
    }

    /* Facility card hover */
    .facility-card {
      transition: transform 0.3s ease, border-color 0.3s ease, background 0.3s ease;
    }
    .facility-card:hover {
      transform: translateY(-3px);
    }

    /* Gallery image hover */
    .gallery-img {
      transition: transform 0.5s ease, filter 0.3s ease;
    }
    .gallery-img:hover {
      transform: scale(1.02);
      filter: brightness(1.08);
    }

    /* Footer link hover */
    .footer-col ul li a {
      transition: color 0.25s, padding-left 0.25s;
    }
    .footer-col ul li a:hover {
      padding-left: 6px;
    }
  `;
  document.head.appendChild(style);

  // ── INTERSECTION OBSERVER ────────────────────────
  function initScrollReveal() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    document.querySelectorAll('.vdp-reveal').forEach(function(el) {
      observer.observe(el);
    });
  }

  // ── TAG ELEMENTS TO ANIMATE ──────────────────────
  function tagElements() {

    // Helper
    function reveal(el, variant, delay) {
      if (!el) return;
      el.classList.add('vdp-reveal');
      if (variant) el.classList.add('vdp-reveal--' + variant);
      if (delay)   el.classList.add('delay-' + delay);
    }

    // Section eyebrows
    document.querySelectorAll('.section-eyebrow').forEach(function(el) {
      reveal(el);
    });

    // Hero content children — stagger
    document.querySelectorAll('.hero-eyebrow').forEach(function(el) { reveal(el, null, 1); });
    document.querySelectorAll('.hero-logo').forEach(function(el) { el.style.animationPlayState = 'running'; });
    document.querySelectorAll('.hero-tagline').forEach(function(el) { reveal(el, null, 2); });
    document.querySelectorAll('.hero-ctas').forEach(function(el) { reveal(el, null, 3); });

    // Home sections — headings
    document.querySelectorAll('h1, h2').forEach(function(el) {
      if (!el.closest('.vdp-nav') && !el.closest('.hero-content')) {
        reveal(el);
      }
    });

    // Paragraphs in brand/community sections
    document.querySelectorAll('.brand-text p, .community-text p, .routes-text p, .signup-text p').forEach(function(el, i) {
      reveal(el, null, Math.min(i + 1, 4));
    });

    // Stats — stagger left to right
    document.querySelectorAll('.brand-stats > div').forEach(function(el, i) {
      reveal(el, null, i + 1);
    });

    // Brand visual
    document.querySelectorAll('.brand-visual').forEach(function(el) {
      reveal(el, 'left');
    });
    document.querySelectorAll('.brand-text').forEach(function(el) {
      reveal(el, 'right');
    });

    // Club cards — stagger
    document.querySelectorAll('.club-card-mini').forEach(function(el, i) {
      reveal(el, 'scale', Math.min((i % 4) + 1, 5));
    });

    // Club full cards
    document.querySelectorAll('.club-full-card').forEach(function(el, i) {
      reveal(el, null, Math.min((i % 2) + 1, 3));
    });

    // Product cards
    document.querySelectorAll('.product-card').forEach(function(el, i) {
      reveal(el, 'scale', Math.min((i % 4) + 1, 5));
    });

    // Coach cards — stagger
    document.querySelectorAll('.coach-card').forEach(function(el, i) {
      reveal(el, null, i + 1);
    });

    // Facility cards
    document.querySelectorAll('.facility-card').forEach(function(el, i) {
      reveal(el, null, Math.min((i % 3) + 1, 4));
    });

    // Rate cards
    document.querySelectorAll('.rate-card').forEach(function(el, i) {
      reveal(el, null, i + 1);
    });

    // Overview quick facts
    document.querySelectorAll('.quick-fact').forEach(function(el, i) {
      reveal(el, null, Math.min(i + 1, 5));
    });

    // Gallery images
    document.querySelectorAll('.gallery-img').forEach(function(el, i) {
      reveal(el, 'scale', Math.min(i + 1, 4));
    });

    // CTA strips
    document.querySelectorAll('.club-cta-strip, .signup-section, .community-section').forEach(function(el) {
      reveal(el, 'scale');
    });

    // Franchise sections
    document.querySelectorAll('.franchise-step, .franchise-stat').forEach(function(el, i) {
      reveal(el, null, Math.min((i % 3) + 1, 4));
    });

    // Footer columns
    document.querySelectorAll('.footer-col').forEach(function(el, i) {
      reveal(el, null, i + 1);
    });

    // Opening hours rows
    document.querySelectorAll('.hours-row').forEach(function(el, i) {
      reveal(el, null, Math.min(i + 1, 5));
    });

    // Map section
    document.querySelectorAll('.club-map-wrap, #map').forEach(function(el) {
      reveal(el, 'scale');
    });

    // Sub nav and masthead
    document.querySelectorAll('.club-masthead').forEach(function(el) {
      reveal(el);
    });
  }

  // ── SMOOTH ANCHOR SCROLL ─────────────────────────
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          var offset = 100;
          var top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });
  }

  // ── PARALLAX on hero ─────────────────────────────
  function initParallax() {
    var heroBg = document.querySelector('.hero-bg');
    if (!heroBg) return;
    window.addEventListener('scroll', function() {
      var scrolled = window.scrollY;
      if (scrolled < window.innerHeight) {
        heroBg.style.transform = 'translateY(' + (scrolled * 0.3) + 'px)';
      }
    }, { passive: true });
  }

  // ── INIT ─────────────────────────────────────────
  function init() {
    tagElements();
    initScrollReveal();
    initSmoothScroll();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
